// extracted by mini-css-extract-plugin
export default {"commandCenter":"commandCenter-qCwkC","tabPanel":"tabPanel-FUWBY","tabs":"tabs-zHKB_"};